<template>
    <div class="grid grid-cols-3 text-22 text-center text-gray-1 cursor-pointer select-none mt-2 pt-2 pb-6" v-show="isShowCode">
        <div class=""
             :class="[serialType == 'QR_CODE' ? classActiveTab : '']"
             @click="changeTab('QR_CODE')">
            {{lbl.serial.qr_code}}
        </div>
        <div class="border-l border-r border-gray-1"
             :class="[serialType == 'CODE_128' ? classActiveTab : '']"
             @click="changeTab('CODE_128')">
            {{lbl.serial.barcode}}
        </div>
        <div class=" "
             :class="[serialType == 'CODE' ? classActiveTab : '']"
             @click="changeTab('CODE')">
            {{lbl.serial.code}}
        </div>
    </div>
    <div>
        <PrivilegeMessage :type="type" :serialModel="serialModel"></PrivilegeMessage>
        <div class="text-22 text-gray-1 text-center">กรุณาแสดงรหัสนี้ที่หน้าร้าน เพื่อรับสิทธิพิเศษ</div>
        <div v-if="serialModel.campaignExpire" class="text-18 text-blue-1 text-center">สิทธิ์หมดอายุวันที่ {{FilterDateFormat(serialModel.campaignExpire)}}</div>
        <div class="text-18 text-green-1 text-center">*หน้าร้านจะไม่รับการแคปหน้าจอในทุกรณี</div>
    </div>
    <div class="flex justify-center items-center wrap-code">
        <div v-show="serialType == 'QR_CODE'">
            <div class=" flex justify-center">
                <VueQrcode :value="serial" :options="qrOption"></VueQrcode>
            </div>
            <div class="text-center w-full text-22 tracking-widest break-all px-5">{{serial}}</div>
        </div>
        <div v-show="serialType == 'CODE_128'">
            <div class=" flex justify-center barcode">
                <VueBarcode :value="serial" :options="barcodeOption"></VueBarcode>
            </div>
            <div class="text-center w-full text-22 tracking-widest break-all px-5">{{serial}}</div>
        </div>
        <div v-show="serialType == 'CODE'" class="flex flex-wrap">
            <div v-if="type == 'surprise-box'" class="text-center w-full text-58 tracking-widest break-all px-2">{{serial}}</div>
            <div v-else class="text-center w-full text-36 tracking-widest break-all px-2">{{serial}}</div>
            <button
                class="text-white bg-green-1 text-center m-auto px-4 rounded-full"
                v-clipboard:copy="serial"
                v-clipboard:success="onCopy">คัดลอก</button>
        </div>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
//lib
import VueBarcode from '@chenfengyuan/vue-barcode';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import PrivilegeMessage from "@/module/Detail/modal/SerialModal/component/PrivilegeMessage.vue";

export default {
    name: "Serial",
    mixins: [LocaleMixin],
    components: {
        VueBarcode,
        VueQrcode,
        PrivilegeMessage,
    },
    props: {
        serialModel: Object,
        type: String
    },
    data: function() {
        return {
            serialType: 'CODE', // CODE, QR_CODE, CODE_128
            classActiveTab: 'text-green-1',

            isExpired: false,
            isLoaded: false,
            isShowCode: true,
            isTabLock: false,
            privilegeMsg: '',
            serial: '',

            qrOption: {
                width: 120,
                margin: 0,
            },
            barcodeOption: {
                width:1,
                height: 70,
                displayValue: false,
                lineColor: '#000000',
            },
        };
    },
    created: function() {
        this.initial();
    },
    methods: {
        initial: function () {
            if (!this.serialModel.serial) {
                return;
            }

            this.isExpired = false;
            this.serial = this.serialModel.serial;
            switch (this.serialModel.serialType) {
                case 'CODE_128':
                    this.serialType = 'CODE_128';
                    break;
                case 'QR_CODE':
                    this.serialType = 'QR_CODE';
                    break;
                default:
                    this.serialType = 'CODE';
                    break;
            }

            if (this.serialModel.barcode && this.serialModel.barcode.toLowerCase() == 'none' && this.serialModel.privilegeMessage) {
                this.isShowCode = false;
            }
        },

        changeTab: function (type) {
            if (this.isTabLock) return;

            this.serialType = type;
        },

        setSerialExpire: function() {
            this.serial = "XXXXXX";
            this.isExpired = true;
            this.isTabLock = true;
            this.serialType = "CODE";
        },
    },
}
</script>
<style lang="scss" scoped>
.wrap-code {
    @media (min-height: 653px) {
        height: 200px;
    }
    .barcode {
        canvas {
            max-width: 100%;
        }
    }
}
</style>
